import { useEffect, useRef } from "react";

const CBID = "75946749-0954-45c5-8a2c-baef9a9ded0f";

/**
 * Cookiebot's cookie declaration — the auto-generated table of every cookie the
 * site sets, which the CMP requires to be published somewhere.
 *
 * It has to be mounted as a real script element rather than pasted into the CMS
 * content the Legal pages render: those go through `dangerouslySetInnerHTML`,
 * and scripts inserted via innerHTML never execute.
 */
export function Cookies() {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const script = document.createElement("script");
    script.id = "CookieDeclaration";
    script.src = `https://consent.cookiebot.com/${CBID}/cd.js`;
    script.type = "text/javascript";
    script.async = true;
    script.setAttribute("data-culture", "EL");
    container.appendChild(script);

    // StrictMode runs effects twice in dev; clearing avoids a duplicate table.
    return () => {
      container.innerHTML = "";
    };
  }, []);

  return (
    <div className="min-h-screen bg-black">
      <div className="max-w-3xl mx-auto px-6 py-24">
        <h1 className="text-4xl font-bold text-white mb-8">Πολιτική Cookies</h1>
        <div ref={containerRef} className="cookie-declaration" />
      </div>
    </div>
  );
}
